import * as Yup from 'yup'

export const initialSuperMidWetValues = {
  wetName: '',
  wetDate: '',
  wetShift: '',
  wetMessage: '',

  ultrasil110: '',
  ac103South: '',
  ac555: '',

  totalRawMilk: '',
  totalSkimMilk: '',
  currentlyFillingMilkSilo: '',
  totalRawCream: '',
  totalPasteurizedCream: '',
  currenlyFillingCreamSilo: '',
  totalPerm: '',
  silosWashed: '',
  htst1CurrentlyPullingMilkSilo: '',
  htst2CurrentlyPullingMilkSilo: '',
  htst1CurrentlyProcessingMilkAt: '',
  htst2CurrentlyProcessingMilkAt: '',
  htst1CurrentlyPullingCreamSilo: '',
  htst2CurrentlyPullingCreamSilo: '',
  htst1CurrentlyProcessingCreamAt: '',
  htst2CurrentlyProcessingCreamAt: '',
  htst1CipType: '',
  htst2CipType: '',
  htst1LastFlush: '',
  htst2LastFlush: '',
  htst1LastOnProduct: '',
  htst2LastOnProduct: '',

  silo1Hours: '',
  silo1Volume: 0,
  silo1Product: '',
  silo1Status: '',
  silo1Snf: '',
  silo1Fat: '',
  silo2Hours: '',
  silo2Volume: 0,
  silo2Product: '',
  silo2Status: '',
  silo2Snf: '',
  silo2Fat: '',
  silo3Hours: '',
  silo3Volume: 0,
  silo3Product: '',
  silo3Status: '',
  silo3Snf: '',
  silo3Fat: '',
  silo4Hours: '',
  silo4Volume: 0,
  silo4Product: '',
  silo4Status: '',
  silo4Snf: '',
  silo4Fat: '',
  silo5Hours: '',
  silo5Volume: 0,
  silo5Product: '',
  silo5Status: '',
  silo5Snf: '',
  silo5Fat: '',
  silo6Hours: '',
  silo6Volume: 0,
  silo6Product: '',
  silo6Status: '',
  silo6Snf: '',
  silo6Fat: '',
  silo7Hours: '',
  silo7Volume: 0,
  silo7Product: '',
  silo7Status: '',
  silo7Snf: '',
  silo7Fat: '',
  silo9Hours: '',
  silo9Volume: 0,
  silo9Product: '',
  silo9Status: '',
  silo9Snf: '',
  silo9Fat: '',
  silo10Hours: '',
  silo10Volume: 0,
  silo10Product: '',
  silo10Status: '',
  silo10Snf: '',
  silo10Fat: '',
  silo11Hours: '',
  silo11Volume: 0,
  silo11Product: '',
  silo11Status: '',
  silo11Snf: '',
  silo11Fat: '',
  silo12Hours: '',
  silo12Volume: 0,
  silo12Product: '',
  silo12Status: '',
  silo12Snf: '',
  silo12Fat: '',
  silo15Hours: '',
  silo15Volume: 0,
  silo15Product: '',
  silo15Status: '',
  silo15Snf: '',
  silo15Fat: '',
  silo24Hours: '',
  silo24Volume: 0,
  silo24Product: '',
  silo24Status: '',
  silo24Snf: '',
  silo24Fat: '',
  silo14Hours: '',
  silo14Volume: 0,
  silo14Product: '',
  silo14Status: '',
  silo14Snf: '',
  silo14Fat: '',
  silo16Hours: '',
  silo16Volume: 0,
  silo16Product: '',
  silo16Status: '',
  silo16Snf: '',
  silo16Fat: '',
  silo26Hours: '',
  silo26Volume: 0,
  silo26Product: '',
  silo26Status: '',
  silo26Snf: '',
  silo26Fat: '',
  silo13Hours: '',
  silo13Volume: 0,
  silo13Product: '',
  silo13Status: '',
  silo13Snf: '',
  silo13Fat: '',
  silo25Hours: '',
  silo25Volume: 0,
  silo25Product: '',
  silo25Status: '',
  silo25Snf: '',
  silo25Fat: '',
  silo22Hours: '',
  silo22Volume: 0,
  silo22Product: '',
  silo22Status: '',
  silo22Snf: '',
  silo22Fat: '',
  silo23Hours: '',
  silo23Volume: 0,
  silo23Product: '',
  silo23Status: '',
  silo23Snf: '',
  silo23Fat: '',
  silo18Hours: '',
  silo18Volume: 0,
  silo18Product: '',
  silo18Status: '',
  silo18Snf: '',
  silo18Fat: '',
  silo19Hours: '',
  silo19Volume: 0,
  silo19Product: '',
  silo19Status: '',
  silo19Snf: '',
  silo19Fat: '',
  silo20Hours: '',
  silo20Volume: 0,
  silo20Product: '',
  silo20Status: '',
  silo20Snf: '',
  silo20Fat: '',
  silo21Hours: '',
  silo21Volume: 0,
  silo21Product: '',
  silo21Status: '',
  silo21Snf: '',
  silo21Fat: '',
  totalWater: '',

  htstTnkHours: '',
  htstTnkVolume: 0,
  htstTnkProduct: '',
  htstTnkStatus: '',
  htstTnkSnf: '',
  htstTnkFat: '',

  evapTnkHours: '',
  evapTnkVolume: 0,
  evapTnkProduct: '',
  evapTnkStatus: '',
  evapTnkSnf: '',
  evapTnkFat: '',

  recoveryTnkHours: '',
  recoveryTnkVolume: 0,
  recoveryTnkProduct: '',
  recoveryTnkStatus: '',
  recoveryTnkSnf: '',
  recoveryTnkFat: '',

  milkRoBaselinePressure: '',
  milkRoLoop1: '',
  milkRoLoop2: '',
  milkRoFeedFlow: '',
  milkRoSolids: '',
  polisherBaselinePressure: '',
  polisherLoop1: '',
  polisherLoop2: '',
  polisherFeedFlow: '',
  permeateRoBaselinePressure: '',
  permeateRoBx: '',
  ufBaselinePressure: '',
  ufBx: '',
  ufProtein: '',
  ufCurrentProduct: '',
  ufLastFlush: '',
  ufLastOnProduct: '',
  nfBaselinePressure: '',
  nfBx: '',

  butterCurrentlyPullingSilo: '',
  butterLastFlushChurn1: '',
  butterLastOnProductChurn1: '',
  butterCreamToChurnRpmChurn1: '',
  butterAvgFatChurn1: '',
  butterAvgSaltChurn1: '',
  butterAvgMoistChurn1: '',
  butterAvgPhChurn1: '',

  butterLastFlushChurn2: '',
  butterLastOnProductChurn2: '',
  butterCreamToChurnRpmChurn2: '',
  butterAvgFatChurn2: '',
  butterAvgSaltChurn2: '',
  butterAvgMoistChurn2: '',
  butterAvgPhChurn2: '',
  butterButtermilkToSilo: '',
  butterPalletsProduced1: '',
  butterProductProduced1: '',
  butterPalletsProduced2: '',
  butterProductProduced2: '',
  butterPalletsProduced3: '',
  butterProductProduced3: '',
  butterTotalPalletsProduced: '',
  butterBoxesOutOfSpec: '',
}

export const SuperMidWetSchema = Yup.object().shape({
  logId: Yup.string(),
  wetName: Yup.string(),
  wetDate: Yup.string(),
  wetShift: Yup.string(),
  wetMessage: Yup.string(),

  ultrasil110: Yup.string(),
  ac103South: Yup.string(),
  ac555: Yup.string(),

  totalUnpasteurizedMilk: Yup.string(),
  totalRawMilk: Yup.string(),
  totalSkimMilk: Yup.string(),
  currentlyFillingMilkSilo: Yup.string(),
  totalRawCream: Yup.string(),
  totalPasteurizedCream: Yup.string(),
  currenlyFillingCreamSilo: Yup.string(),
  totalPerm: Yup.string(),
  silosWashed: Yup.string(),
  htst1CurrentlyPullingMilkSilo: Yup.string(),
  htst2CurrentlyPullingMilkSilo: Yup.string(),
  htst1CurrentlyProcessingMilkAt: Yup.string(),
  htst2CurrentlyProcessingMilkAt: Yup.string(),
  htst1CurrentlyPullingCreamSilo: Yup.string(),
  htst2CurrentlyPullingCreamSilo: Yup.string(),
  htst1CurrentlyProcessingCreamAt: Yup.string(),
  htst2CurrentlyProcessingCreamAt: Yup.string(),
  htst1CipType: Yup.string(),
  htst2CipType: Yup.string(),
  htst1LastFlush: Yup.string(),
  htst2LastFlush: Yup.string(),
  htst1LastOnProduct: Yup.string(),
  htst2LastOnProduct: Yup.string(),

  silo1Hours: Yup.string(),
  silo1Volume: Yup.number(),
  silo1Product: Yup.string(),
  silo1Status: Yup.string(),
  silo1Snf: Yup.string(),
  silo1Fat: Yup.string(),
  silo2Hours: Yup.string(),
  silo2Volume: Yup.number(),
  silo2Product: Yup.string(),
  silo2Status: Yup.string(),
  silo2Snf: Yup.string(),
  silo2Fat: Yup.string(),
  silo3Hours: Yup.string(),
  silo3Volume: Yup.number(),
  silo3Product: Yup.string(),
  silo3Status: Yup.string(),
  silo3Snf: Yup.string(),
  silo3Fat: Yup.string(),
  silo4Hours: Yup.string(),
  silo4Volume: Yup.number(),
  silo4Product: Yup.string(),
  silo4Status: Yup.string(),
  silo4Snf: Yup.string(),
  silo4Fat: Yup.string(),
  silo5Hours: Yup.string(),
  silo5Volume: Yup.number(),
  silo5Product: Yup.string(),
  silo5Status: Yup.string(),
  silo5Snf: Yup.string(),
  silo5Fat: Yup.string(),
  silo6Hours: Yup.string(),
  silo6Volume: Yup.number(),
  silo6Product: Yup.string(),
  silo6Status: Yup.string(),
  silo6Snf: Yup.string(),
  silo6Fat: Yup.string(),
  silo7Hours: Yup.string(),
  silo7Volume: Yup.number(),
  silo7Product: Yup.string(),
  silo7Status: Yup.string(),
  silo7Snf: Yup.string(),
  silo7Fat: Yup.string(),
  silo9Hours: Yup.string(),
  silo9Volume: Yup.number(),
  silo9Product: Yup.string(),
  silo9Status: Yup.string(),
  silo9Snf: Yup.string(),
  silo9Fat: Yup.string(),
  silo10Hours: Yup.string(),
  silo10Volume: Yup.number(),
  silo10Product: Yup.string(),
  silo10Status: Yup.string(),
  silo10Snf: Yup.string(),
  silo10Fat: Yup.string(),
  silo11Hours: Yup.string(),
  silo11Volume: Yup.number(),
  silo11Product: Yup.string(),
  silo11Status: Yup.string(),
  silo11Snf: Yup.string(),
  silo11Fat: Yup.string(),
  silo12Hours: Yup.string(),
  silo12Volume: Yup.number(),
  silo12Product: Yup.string(),
  silo12Status: Yup.string(),
  silo12Snf: Yup.string(),
  silo12Fat: Yup.string(),
  silo15Hours: Yup.string(),
  silo15Volume: Yup.number(),
  silo15Product: Yup.string(),
  silo15Status: Yup.string(),
  silo15Snf: Yup.string(),
  silo15Fat: Yup.string(),
  silo24Hours: Yup.string(),
  silo24Volume: Yup.number(),
  silo24Product: Yup.string(),
  silo24Status: Yup.string(),
  silo24Snf: Yup.string(),
  silo24Fat: Yup.string(),
  silo14Hours: Yup.string(),
  silo14Volume: Yup.number(),
  silo14Product: Yup.string(),
  silo14Status: Yup.string(),
  silo14Snf: Yup.string(),
  silo14Fat: Yup.string(),
  silo16Hours: Yup.string(),
  silo16Volume: Yup.number(),
  silo16Product: Yup.string(),
  silo16Status: Yup.string(),
  silo16Snf: Yup.string(),
  silo16Fat: Yup.string(),
  silo26Hours: Yup.string(),
  silo26Volume: Yup.number(),
  silo26Product: Yup.string(),
  silo26Status: Yup.string(),
  silo26Snf: Yup.string(),
  silo26Fat: Yup.string(),
  silo13Hours: Yup.string(),
  silo13Volume: Yup.number(),
  silo13Product: Yup.string(),
  silo13Status: Yup.string(),
  silo13Snf: Yup.string(),
  silo13Fat: Yup.string(),
  silo25Hours: Yup.string(),
  silo25Volume: Yup.number(),
  silo25Product: Yup.string(),
  silo25Status: Yup.string(),
  silo25Snf: Yup.string(),
  silo25Fat: Yup.string(),
  silo22Hours: Yup.string(),
  silo22Volume: Yup.number(),
  silo22Product: Yup.string(),
  silo22Status: Yup.string(),
  silo22Snf: Yup.string(),
  silo22Fat: Yup.string(),
  silo23Hours: Yup.string(),
  silo23Volume: Yup.number(),
  silo23Product: Yup.string(),
  silo23Status: Yup.string(),
  silo23Snf: Yup.string(),
  silo23Fat: Yup.string(),
  silo18Hours: Yup.string(),
  silo18Volume: Yup.number(),
  silo18Product: Yup.string(),
  silo18Status: Yup.string(),
  silo18Snf: Yup.string(),
  silo18Fat: Yup.string(),
  silo19Hours: Yup.string(),
  silo19Volume: Yup.number(),
  silo19Product: Yup.string(),
  silo19Status: Yup.string(),
  silo19Snf: Yup.string(),
  silo19Fat: Yup.string(),
  silo20Hours: Yup.string(),
  silo20Volume: Yup.number(),
  silo20Product: Yup.string(),
  silo20Status: Yup.string(),
  silo20Snf: Yup.string(),
  silo20Fat: Yup.string(),
  silo21Hours: Yup.string(),
  silo21Volume: Yup.number(),
  silo21Product: Yup.string(),
  silo21Status: Yup.string(),
  silo21Snf: Yup.string(),
  silo21Fat: Yup.string(),
  totalWater: Yup.string(),

  htstTnkHours: Yup.string(),
  htstTnkVolume: Yup.number(),
  htstTnkProduct: Yup.string(),
  htstTnkStatus: Yup.string(),
  htstTnkSnf: Yup.string(),
  htstTnkFat: Yup.string(),

  evapTnkHours: Yup.string(),
  evapTnkVolume: Yup.number(),
  evapTnkProduct: Yup.string(),
  evapTnkStatus: Yup.string(),
  evapTnkSnf: Yup.string(),
  evapTnkFat: Yup.string(),

  recoveryTnkHours: Yup.string(),
  recoveryTnkVolume: Yup.number(),
  recoveryTnkProduct: Yup.string(),
  recoveryTnkStatus: Yup.string(),
  recoveryTnkSnf: Yup.string(),
  recoveryTnkFat: Yup.string(),

  milkRoBaselinePressure: Yup.string(),
  milkRoLoop1: Yup.string(),
  milkRoLoop2: Yup.string(),
  milkRoFeedFlow: Yup.string(),
  milkRoSolids: Yup.string(),
  polisherBaselinePressure: Yup.string(),
  polisherLoop1: Yup.string(),
  polisherLoop2: Yup.string(),
  polisherFeedFlow: Yup.string(),
  permeateRoBaselinePressure: Yup.string(),
  permeateRoBx: Yup.string(),
  ufBaselinePressure: Yup.string(),
  ufBx: Yup.string(),
  ufProtein: Yup.string(),
  ufCurrentProduct: Yup.string(),
  ufLastFlush: Yup.string(),
  ufLastOnProduct: Yup.string(),
  nfBaselinePressure: Yup.string(),
  nfBx: Yup.string(),

  butterCurrentlyPullingSilo: Yup.string(),
  butterLastFlushChurn1: Yup.string(),
  butterLastOnProductChurn1: Yup.string(),
  butterCreamToChurnRpmChurn1: Yup.string(),
  butterAvgFatChurn1: Yup.string(),
  butterAvgSaltChurn1: Yup.string(),
  butterAvgMoistChurn1: Yup.string(),
  butterAvgPhChurn1: Yup.string(),

  butterLastFlushChurn2: Yup.string(),
  butterLastOnProductChurn2: Yup.string(),
  butterCreamToChurnRpmChurn2: Yup.string(),
  butterAvgFatChurn2: Yup.string(),
  butterAvgSaltChurn2: Yup.string(),
  butterAvgMoistChurn2: Yup.string(),
  butterAvgPhChurn2: Yup.string(),
  butterButtermilkToSilo: Yup.string(),
  butterPalletsProduced1: Yup.number(),
  butterProductProduced1: Yup.string(),
  butterPalletsProduced2: Yup.number(),
  butterProductProduced2: Yup.string(),
  butterPalletsProduced3: Yup.number(),
  butterProductProduced3: Yup.string(),
  butterTotalPalletsProduced: Yup.string(),
  butterBoxesOutOfSpec: Yup.string(),
})
